import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  let {type} = theme.palette;
  let colorType = type === "dark" ? "light" : "dark";
  let color = p => p.mine ? "primary" : "secondary";
  return {
    container: {
      textAlign: p => p.mine ? "right" : "left",
      marginTop: p => theme.spacing(p.fromNew ? 3 : 1),
      width: "100%",
      display: "flex",
      flexFlow: "column",
      alignItems: p => p.mine ? "end" : "start"
    },
    text: {
      backgroundColor: p => theme.palette[color(p)][colorType],
      color: p => theme.palette.getContrastText(
        theme.palette[color(p)][colorType]
      ),
      borderRadius: "4px",
      padding: "5px 8px",
      boxSizing: "border-box",
      maxWidth: "70%"
    },
    pseudoContainer: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      justifyContent: "flex-start",
      boxSizing: "border-box",
      marginBottom: theme.spacing(1)
    },
    avatar: {
      maxWidth: 30,
      height: 20,
      marginRight: theme.spacing(1)
    },
    pseudo: {

    },

    dividerLine: {
      height: theme.spacing(1)
    }
  }
});
